(() => {
  if (window.__gfInit) return;
  window.__gfInit = true;

  const MONTHS = ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαΐ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'];
  const money = (cents) => `${(Math.round(cents) / 100).toFixed(2).replace('.', ',')} €`;
  const parse = (json) => { try { return JSON.parse(json || '{}') || {}; } catch { return {}; } };
  const plural = (n, one, many) => (n === 1 ? one : many);

  /* ---------- pricing model (mirrors the automatic discounts) ----------
     azyl  (Καταφύγιο bracelets): 2+ items −20%
     miyuki: every 2nd item −40% (buy 1 get 1 −40%)
     neck  (all necklaces): 2 items −15%, 3+ items −20%                 */
  const GROUPS = ['azyl', 'miyuki', 'neck'];
  function groupTotal(P, key, n, v) {
    const g = P[key] || {};
    if (!n) return 0;
    const unit = v / n;
    if (key === 'azyl') return n >= 2 ? Math.round(v - n * Math.floor(unit * (g.p2 || 20) / 100)) : v;
    if (key === 'neck') {
      const pct = n >= 3 ? (g.p3 || 20) : n >= 2 ? (g.p2 || 15) : 0;
      return Math.round(v - n * Math.floor(unit * pct / 100));
    }
    if (key === 'miyuki') return Math.round(v - Math.floor(n / 2) * Math.floor(unit * (g.off || 40) / 100));
    return v;
  }
  function cartTotal(P, state) {
    return GROUPS.reduce((s, k) => s + groupTotal(P, k, (state[k] || {}).n || 0, (state[k] || {}).v || 0), 0);
  }
  function merge(a, b) {
    const out = {};
    GROUPS.forEach((k) => {
      out[k] = { n: ((a[k] || {}).n || 0) + ((b[k] || {}).n || 0), v: ((a[k] || {}).v || 0) + ((b[k] || {}).v || 0) };
    });
    return out;
  }
  /* cost of adding `extra` on top of what is already in the cart */
  function delta(P, extra) {
    const have = P.have || {};
    const list = GROUPS.reduce((s, k) => s + ((extra[k] || {}).v || 0), 0);
    const add = cartTotal(P, merge(have, extra)) - cartTotal(P, have);
    return { list, add: add > 0 && add <= list ? add : list };
  }
  window.GF = Object.assign(window.GF || {}, { money, delta, groupTotal });

  /* ---------- cart helpers ---------- */
  async function addItems(items, source = 'gf-upsell') {
    const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
    const body = { items };
    if (ids.length) {
      body.sections = [...new Set(ids)].join(',');
      body.sections_url = window.location.pathname;
    }
    const routes = (window.Theme && window.Theme.routes) || {};
    const res = await fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || 'Δεν ήταν δυνατή η προσθήκη στο καλάθι.');
    const cart = await fetch(`${routes.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    /* Horizon 4.2 morphs cart sections only on its own cart-lines events, so morph them here */
    if (json.sections) {
      try {
        const { morphSection } = await import('@theme/section-renderer');
        for (const el of document.querySelectorAll('cart-items-component')) {
          const id = el.dataset.sectionId;
          if (id && json.sections[id]) await morphSection(id, json.sections[id], { mode: el.isDrawer ? 'hydration' : 'full' });
        }
      } catch (e) { /* theme will refresh on next load */ }
    }
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'gf', data: { source, itemCount: cart.item_count, sections: json.sections } },
    }));
    return cart;
  }
  function flashError(host, message) {
    if (!host) return;
    let box = host.querySelector('.nl-form-err');
    if (!box) {
      box = document.createElement('div');
      box.className = 'nl-form-err';
      box.setAttribute('role', 'alert');
      host.appendChild(box);
    }
    box.textContent = message;
    clearTimeout(box.__t);
    box.__t = setTimeout(() => box.remove(), 6000);
  }
  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.open === 'function') drawer.open();
    else if (typeof drawer.showDialog === 'function') drawer.showDialog();
  }

  /* ---------- product page bundle tiers ---------- */
  class NlBundle extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-variant-mode') && !this.__onVariant) {
        this.__onVariant = (e) => {
          const detail = e.detail || {};
          const v = detail.resource;
          if (!v || !v.id) return;
          if (detail.data && detail.data.productId && this.dataset.product && String(detail.data.productId) !== this.dataset.product) return;
          this.setMain(String(v.id));
        };
        document.addEventListener('variant:update', this.__onVariant);
      }
      if (this.__ready) return;
      this.__ready = true;
      this.sheet = this.querySelector('dialog.nl-sheet');
      this.addEventListener('change', (e) => {
        if (e.target instanceof HTMLInputElement && e.target.classList.contains('nl-tier__input')) this.sync();
      });
      this.addEventListener('click', (e) => {
        const el = e.target instanceof Element ? e.target : null;
        if (!el) return;
        const change = el.closest('.nl-pick__btn');
        if (change) { e.preventDefault(); this.openSheet(change.closest('.nl-pick')); return; }
        const opt = el.closest('.nl-opt');
        if (opt && !opt.disabled) { e.preventDefault(); this.choose(opt); return; }
        if (el.closest('.nl-sheet__close') || el === this.sheet) this.sheet?.close();
      });
      this.reprice();
      this.sync();
    }
    disconnectedCallback() {
      if (this.__onVariant) document.removeEventListener('variant:update', this.__onVariant);
      this.__onVariant = null;
    }
    setMain(id) {
      const old = this.dataset.variant;
      if (!id || id === old) return;
      const opt = this.sheet ? this.sheet.querySelector(`.nl-opt[data-id="${id}"]`) : null;
      this.dataset.variant = id;
      if (opt && opt.dataset.price) this.dataset.price = opt.dataset.price;
      this.querySelectorAll('.nl-picks').forEach((box) => {
        box.querySelectorAll('.nl-pick').forEach((row, index) => {
          if (index !== 0 && row.dataset.variant !== old) return;
          row.dataset.variant = id;
          if (!opt) return;
          if (opt.dataset.price) row.dataset.price = opt.dataset.price;
          const img = row.querySelector('img');
          if (img && opt.dataset.img) { img.removeAttribute('srcset'); img.src = opt.dataset.img; }
          const name = row.querySelector('b');
          if (name) name.textContent = opt.dataset.title || '';
        });
      });
      this.reprice();
      this.sync();
    }
    reprice() {
      const main = Number(this.dataset.price) || 0;
      const mode = this.dataset.group || 'neck';
      this.querySelectorAll('.nl-tier[data-pct]').forEach((tier) => {
        const qty = Number(tier.dataset.qty) || 1;
        const rows = [...tier.querySelectorAll('.nl-pick')];
        let regular = 0;
        const prices = [];
        for (let i = 0; i < qty; i++) { const pr = (rows[i] && Number(rows[i].dataset.price)) || main; prices.push(pr); regular += pr; }
        let total = regular;
        if (mode === 'neck' || mode === 'azyl') {
          const pct = mode === 'azyl' ? (qty >= 2 ? 20 : 0) : qty >= 3 ? 20 : qty >= 2 ? 15 : 0;
          total = prices.reduce((s, pr) => s + pr - Math.floor(pr * pct / 100), 0);
        } else {
          const sorted = [...prices].sort((a, b) => a - b);
          const pairs = Math.floor(qty / 2);
          total = regular - sorted.slice(0, pairs).reduce((s, pr) => s + Math.floor(pr * 40 / 100), 0);
        }
        tier.dataset.total = money(total);
        const set = (sel, v) => { const n = tier.querySelector(sel); if (n) n.textContent = v; };
        set('[data-nl-tt]', money(total));
        set('[data-nl-tr]', money(regular));
        set('[data-nl-te]', money(total / qty));
        set('[data-nl-ts]', money(regular - total));
      });
    }
    get qty() {
      const on = this.querySelector('.nl-tier__input:checked');
      return on ? Number(on.value) : 1;
    }
    sync() {
      let total = '';
      this.querySelectorAll('.nl-tier').forEach((tier) => {
        const input = tier.querySelector('.nl-tier__input');
        const on = !!input && input.checked;
        tier.classList.toggle('is-on', on);
        if (on) total = tier.dataset.total || '';
      });
      (this.closest('.shopify-section, dialog') || document).querySelectorAll('.add-to-cart-text__content').forEach((el) => {
        if (total) el.dataset.nlTotal = total;
        else delete el.dataset.nlTotal;
      });
    }
    openSheet(pick) {
      if (!this.sheet || !pick) return;
      this.__target = pick;
      this.sheet.querySelectorAll('.nl-opt').forEach((o) => o.classList.toggle('is-on', o.dataset.id === pick.dataset.variant));
      if (typeof this.sheet.showModal === 'function') this.sheet.showModal();
      else this.sheet.setAttribute('open', '');
    }
    choose(opt) {
      const pick = this.__target;
      if (pick) {
        const index = [...pick.parentElement.querySelectorAll('.nl-pick')].indexOf(pick);
        this.querySelectorAll('.nl-picks').forEach((box) => {
          const row = box.querySelectorAll('.nl-pick')[index];
          if (!row || index === 0) return;
          row.dataset.variant = opt.dataset.id;
          const img = row.querySelector('img');
          if (img && opt.dataset.img) { img.removeAttribute('srcset'); img.src = opt.dataset.img; }
          const name = row.querySelector('b');
          if (name) name.textContent = opt.dataset.title || '';
          if (opt.dataset.price) row.dataset.price = opt.dataset.price;
        });
      }
      this.reprice();
      this.sync();
      this.sheet?.close();
      pick?.querySelector('.nl-pick__btn')?.focus();
    }
    items(mainVariant) {
      const map = new Map();
      const push = (id) => map.set(String(id), (map.get(String(id)) || 0) + 1);
      const tier = this.querySelector('.nl-tier.is-on');
      (tier ? [...tier.querySelectorAll('.nl-pick')] : []).forEach((pick, i) => {
        const v = pick.dataset.variant;
        push(i === 0 || !v || v === this.dataset.variant ? mainVariant : v);
      });
      let count = [...map.values()].reduce((a, b) => a + b, 0);
      for (; count < this.qty; count++) push(mainVariant);
      return [...map.entries()].map(([id, quantity]) => ({ id: Number(id), quantity }));
    }
  }
  if (!customElements.get('nl-bundle')) customElements.define('nl-bundle', NlBundle);

  window.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const pf = form.closest('product-form-component');
    if (!pf) return;
    const bundle = (pf.closest('.shopify-section, .quick-add-modal__content, dialog') || document).querySelector('nl-bundle');
    if (!(bundle instanceof NlBundle) || bundle.qty <= 1) return;
    const idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const btn = form.querySelector('[ref="addToCartButton"], button[type="submit"]');
    if (btn?.classList.contains('is-loading')) return;
    btn?.classList.add('is-loading');
    btn?.setAttribute('aria-busy', 'true');
    addItems(bundle.items(idInput.value), 'nl-bundle')
      .catch((err) => flashError(bundle, err.message))
      .finally(() => { btn?.classList.remove('is-loading'); btn?.removeAttribute('aria-busy'); });
  }, true);

  /* ---------- set builder ---------- */
  const BUILD_WORDS = {
    azyl: { one: 'βραχιόλι Καταφύγιο' },
    miyuki: { one: 'βραχιόλι Miyuki' },
    neck: { one: 'κολιέ' },
  };
  class NlBuilder extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.P = parse(this.dataset.nlPricing);
      this.picked = new Map();
      this.addEventListener('click', (e) => {
        const el = e.target instanceof Element ? e.target : null;
        if (!el) return;
        const tile = el.closest('[data-nl-tile]');
        if (tile && el.closest('[data-nl-inc]')) return this.setQty(tile, this.qty(tile) + 1);
        if (tile && el.closest('[data-nl-dec]')) return this.setQty(tile, this.qty(tile) - 1);
        if (tile && el.closest('.nl-btile__pick')) return this.setQty(tile, this.qty(tile) ? 0 : 1);
        const remove = el.closest('[data-nl-remove]');
        if (remove) {
          const target = this.querySelector(`[data-nl-tile="${remove.dataset.nlRemove}"]`);
          if (target) this.setQty(target, 0);
          return;
        }
        const add = el.closest('[data-nl-build-add]');
        if (add) this.submit(add);
      });
      this.render();
    }
    qty(tile) { const row = this.picked.get(tile.dataset.nlTile); return row ? row.qty : 0; }
    setQty(tile, value) {
      const qty = Math.max(0, Math.min(9, value));
      if (qty) this.picked.set(tile.dataset.nlTile, { qty, tile });
      else this.picked.delete(tile.dataset.nlTile);
      tile.classList.toggle('is-on', qty > 0);
      const pick = tile.querySelector('.nl-btile__pick');
      if (pick) pick.setAttribute('aria-pressed', String(qty > 0));
      const box = tile.querySelector('.nl-btile__qty');
      if (box) {
        box.hidden = !qty;
        const out = box.querySelector('output');
        if (out) out.textContent = String(qty || 1);
      }
      this.render();
    }
    counts() {
      const extra = {};
      let list = 0;
      let count = 0;
      this.picked.forEach(({ qty, tile }) => {
        const key = tile.dataset.group;
        const price = Number(tile.dataset.price) || 0;
        extra[key] = extra[key] || { n: 0, v: 0 };
        extra[key].n += qty;
        extra[key].v += qty * price;
        list += qty * price;
        count += qty;
      });
      const model = delta(this.P, extra);
      return { extra, list, count, total: model.list === list ? model.add : list };
    }
    groupDeals() {
      this.querySelectorAll('[data-nl-group]').forEach((group) => {
        const key = group.dataset.nlGroup;
        const node = group.querySelector('[data-nl-deal]');
        const unit = Number(group.dataset.unit) || 0;
        if (!node || !unit) return;
        if (node.dataset.base === undefined) node.dataset.base = node.textContent.trim();
        const two = delta({ ...this.P, have: {} }, { [key]: { n: 2, v: 2 * unit } });
        const three = delta({ ...this.P, have: {} }, { [key]: { n: 3, v: 3 * unit } });
        const parts = [];
        if (two.add < two.list) parts.push(`2 τεμ. <b>${money(two.add)}</b>`);
        if (three.add < three.list) parts.push(`3 τεμ. <b>${money(three.add)}</b>`);
        const html = parts.length ? `${parts.join(' · ')} <span>— ${node.dataset.base}</span>` : node.dataset.base;
        if (node.innerHTML !== html) node.innerHTML = html;
      });
    }
    render() {
      const { extra, list, count, total } = this.counts();
      this.groupDeals();
      const $ = (sel) => this.querySelector(sel);
      const listNode = $('[data-nl-list]');
      if (listNode) {
        listNode.hidden = !count;
        listNode.innerHTML = '';
        this.picked.forEach(({ qty, tile }, id) => {
          const li = document.createElement('li');
          const img = document.createElement('img');
          img.src = tile.dataset.img || '';
          img.alt = '';
          img.width = 44;
          img.height = 44;
          img.loading = 'lazy';
          const name = document.createElement('span');
          name.className = 'nl-builder__name';
          name.textContent = `${tile.dataset.title || ''}${qty > 1 ? ` × ${qty}` : ''}`;
          const price = document.createElement('span');
          price.className = 'nl-builder__lprice';
          price.textContent = money(qty * (Number(tile.dataset.price) || 0));
          const x = document.createElement('button');
          x.type = 'button';
          x.className = 'nl-builder__x';
          x.dataset.nlRemove = id;
          x.setAttribute('aria-label', `Αφαίρεση από το σετ: ${tile.dataset.title || ''}`);
          x.textContent = '✕';
          li.append(img, name, price, x);
          listNode.append(li);
        });
      }
      const empty = $('[data-nl-empty]');
      if (empty) empty.hidden = !!count;
      const countNode = $('[data-nl-count]');
      if (countNode) countNode.textContent = count ? `(${count})` : '';
      const nudge = $('[data-nl-nudge]');
      if (nudge) {
        let best = null;
        Object.keys(BUILD_WORDS).forEach((key) => {
          const group = this.querySelector(`[data-nl-group="${key}"]`);
          const unit = group ? Number(group.dataset.unit) || 0 : 0;
          if (!unit) return;
          const plus = { ...extra, [key]: { n: ((extra[key] || {}).n || 0) + 1, v: ((extra[key] || {}).v || 0) + unit } };
          const step = delta(this.P, plus).add - (count ? delta(this.P, extra).add : 0);
          const saving = unit - step;
          if (saving > 0 && (!best || saving > best.saving)) best = { key, step, saving };
        });
        nudge.hidden = !best;
        if (best) nudge.innerHTML = `💡 Πρόσθεσε άλλο 1 ${BUILD_WORDS[best.key].one} — θα πληρώσεις μόνο <b>${money(best.step)}</b>.`;
      }
      const goal = Number(this.P.threshold) || 0;
      const ship = $('[data-nl-freeship]');
      if (ship && goal > 0) {
        const sum = (Number(this.P.cartTotal) || 0) + total;
        ship.hidden = !count;
        const text = $('[data-nl-freeship-text]');
        const bar = $('[data-nl-freeship-bar]');
        if (text) text.innerHTML = sum >= goal ? '🚚 Έχεις <b>δωρεάν αποστολή</b>' : `🚚 Για δωρεάν αποστολή λείπουν <b>${money(goal - sum)}</b>`;
        if (bar) bar.style.width = `${Math.min(100, Math.round((sum / goal) * 100))}%`;
      }
      const sumBox = $('[data-nl-sum]');
      if (sumBox) sumBox.hidden = !count;
      const setText = (sel, value) => { const node = $(sel); if (node) node.textContent = value; };
      setText('[data-nl-list-price]', money(list));
      setText('[data-nl-saved]', `−${money(list - total)}`);
      setText('[data-nl-total]', money(total));
      const savedRow = $('[data-nl-saved-row]');
      if (savedRow) savedRow.hidden = !(list > total);
      this.querySelectorAll('[data-nl-build-add]').forEach((btn) => {
        if (btn.classList.contains('is-loading')) return;
        btn.disabled = !count;
        if (btn.classList.contains('nl-builder__add')) btn.textContent = count ? `Πρόσθεσε το σετ στο καλάθι — ${money(total)}` : 'Διάλεξε προϊόντα';
      });
      const dock = $('[data-nl-dock]');
      if (dock) dock.hidden = !count;
      setText('[data-nl-dock-count]', `${count} ${plural(count, 'προϊόν', 'προϊόντα')}`);
      const dockTotal = $('[data-nl-dock-total]');
      if (dockTotal) dockTotal.innerHTML = list > total ? `${money(total)} <s>${money(list)}</s>` : money(total);
    }
    submit(btn) {
      if (!this.picked.size || btn.classList.contains('is-loading')) return;
      const items = [...this.picked.entries()].map(([id, row]) => ({ id: Number(id), quantity: row.qty }));
      const { extra } = this.counts();
      const buttons = [...this.querySelectorAll('[data-nl-build-add]')];
      buttons.forEach((b) => { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      addItems(items, 'nl-builder')
        .then((cart) => {
          this.P.have = merge(this.P.have || {}, extra);
          this.P.cartTotal = Number(cart && cart.total_price) || this.P.cartTotal;
          [...this.picked.values()].forEach(({ tile }) => this.setQty(tile, 0));
          openCartDrawer();
        })
        .catch((err) => flashError(this.querySelector('.nl-builder__side'), err.message))
        .finally(() => {
          buttons.forEach((b) => { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
          this.render();
        });
    }
  }
  if (!customElements.get('nl-builder')) customElements.define('nl-builder', NlBuilder);

  /* ---------- post add-to-cart offer popup ---------- */
  const OFFER_KEY = 'gfOffer';
  const OFFER_MAX = 2;
  let offerBusy = false;
  const offerState = () => { try { return JSON.parse(sessionStorage.getItem(OFFER_KEY) || '{}') || {}; } catch { return {}; } };
  const offerSave = (patch) => { try { sessionStorage.setItem(OFFER_KEY, JSON.stringify({ ...offerState(), ...patch })); } catch {} };
  function offerEligible() {
    if (offerBusy || (window.Shopify && window.Shopify.designMode) || /\/cart\/?$/.test(window.location.pathname)) return false;
    const st = offerState();
    return !st.off && !st.declined && (st.shown || 0) < OFFER_MAX;
  }
  async function fetchOffer() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 2500);
    try {
      const res = await fetch(`${root}?section_id=nl-offer`, { signal: ctrl.signal, headers: { Accept: 'text/html' } });
      if (!res.ok) return { content: null, disabled: false };
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      return { content: doc.querySelector('[data-nl-offer]'), disabled: !!doc.querySelector('[data-nl-offer-disabled]') };
    } catch {
      return { content: null, disabled: false };
    } finally {
      clearTimeout(timer);
    }
  }
  const OFFER_WORDS = {
    azyl: { next: 'το επόμενο μόνο', have: ['βραχιόλι', 'βραχιόλια'] },
    miyuki: { next: 'το επόμενο μόνο', have: ['Miyuki', 'Miyuki'] },
    neck: { next: 'το επόμενο μόνο', have: ['κολιέ', 'κολιέ'] },
  };
  function offerShop(dialog) {
    const body = dialog.querySelector('[data-nl-offer="shop"]');
    if (!body) return null;
    const tabs = [...body.querySelectorAll('[data-nl-offer-tab]')];
    const panels = [...body.querySelectorAll('[data-nl-offer-panel]')];
    const yes = body.querySelector('[data-nl-offer-accept]');
    const P = parse(body.dataset.nlPricing);
    const have = P.have || {};
    panels.forEach((panel) => {
      const key = panel.dataset.nlOfferPanel;
      const words = OFFER_WORDS[key];
      const hint = panel.querySelector('.nl-offer__hint:not(.nl-offer__hint--static)');
      const unit = Number(panel.dataset.unit) || 0;
      if (!words || !hint || !unit) return;
      const base = hint.textContent.trim();
      const one = delta(P, { [key]: { n: 1, v: unit } });
      const two = delta(P, { [key]: { n: 2, v: 2 * unit } });
      const owned = (have[key] || {}).n || 0;
      let lead = '';
      if (owned > 0 && one.add < one.list) lead = `Έχεις ήδη ${owned} ${plural(owned, ...words.have)} — <b>${words.next} ${money(one.add)}</b>.`;
      else if (two.add < two.list) lead = `<b>2 τεμ. ${money(two.add)}</b> αντί για ${money(two.list)}.`;
      if (lead) hint.innerHTML = `${lead} <span>${base}</span>`;
    });
    function update() {
      let count = 0;
      let list = 0;
      const extra = {};
      panels.forEach((panel) => {
        const key = panel.dataset.nlOfferPanel;
        const on = [...panel.querySelectorAll('[data-nl-offer-tile][aria-pressed="true"]')];
        const badge = body.querySelector(`[data-nl-offer-tab="${key}"] .nl-offer__count`);
        if (badge) { badge.hidden = !on.length; badge.textContent = String(on.length); }
        on.forEach((t) => {
          const price = Number(t.dataset.price) || 0;
          count += 1;
          list += price;
          extra[key] = extra[key] || { n: 0, v: 0 };
          extra[key].n += 1;
          extra[key].v += price;
        });
      });
      const add = count ? delta(P, extra).add : 0;
      const set = (sel, text) => { const node = body.querySelector(sel); if (node) node.textContent = text; return node; };
      set('[data-nl-offer-count]', count ? `Επιλέχθηκαν: ${count} ${plural(count, 'προϊόν', 'προϊόντα')}` : 'Διάλεξε τι θέλεις να προσθέσεις');
      set('[data-nl-offer-price]', count ? money(add) : '');
      set('[data-nl-offer-was]', count && list > add ? money(list) : '');
      const note = body.querySelector('[data-nl-offer-note]');
      if (note) {
        note.hidden = !(count && list > add);
        note.textContent = note.hidden ? '' : `Εξοικονομείς ${money(list - add)} · η έκπτωση εφαρμόζεται στο καλάθι`;
      }
      const ship = body.querySelector('[data-nl-offer-ship]');
      if (ship) {
        const total = Number(P.cartTotal) || 0;
        const goal = Number(P.threshold) || 0;
        ship.hidden = !(count && goal > 0 && total < goal && total + add >= goal);
      }
      if (yes && !yes.classList.contains('is-done')) {
        yes.disabled = !count;
        yes.textContent = count
          ? count === 1 ? `Ναι, θέλω — πρόσθεσε για ${money(add)}` : `Ναι, θέλω — πρόσθεσε ${count} για ${money(add)}`
          : 'Ναι, θέλω — διάλεξε προϊόν';
      }
    }
    function select(name) {
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t.dataset.nlOfferTab === name)));
      panels.forEach((p) => { p.hidden = p.dataset.nlOfferPanel !== name; });
    }
    function toggle(tile) {
      const on = tile.getAttribute('aria-pressed') !== 'true';
      tile.setAttribute('aria-pressed', String(on));
      tile.classList.toggle('is-on', on);
      update();
    }
    const start = body.dataset.tab || (tabs[0] && tabs[0].dataset.nlOfferTab);
    select(start);
    const startPanel = panels.find((p) => p.dataset.nlOfferPanel === start);
    if (startPanel) {
      const pre = startPanel.querySelector('[data-nl-offer-tile]');
      if (pre) { pre.setAttribute('aria-pressed', 'true'); pre.classList.add('is-on'); }
    }
    update();
    return {
      select,
      toggle,
      items: () => [...body.querySelectorAll('[data-nl-offer-tile][aria-pressed="true"]')].map((t) => ({ id: Number(t.dataset.nlOfferTile), quantity: 1 })),
    };
  }
  function showOffer(content) {
    return new Promise((resolve) => {
      const dialog = document.createElement('dialog');
      dialog.className = 'nl nl-offer';
      dialog.setAttribute('aria-labelledby', 'nl-offer-title');
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'nl-offer__close';
      close.setAttribute('aria-label', 'Κλείσιμο');
      close.dataset.nlOfferDecline = '';
      close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      dialog.append(close, document.importNode(content, true));
      document.body.append(dialog);
      const shop = offerShop(dialog);
      let result = 'dismissed';
      let settled = false;
      const cleanup = () => { if (settled) return; settled = true; dialog.remove(); resolve(result); };
      const finish = (value) => {
        result = value;
        dialog.classList.add('is-closing');
        setTimeout(() => { if (dialog.open) dialog.close(); cleanup(); }, 180);
      };
      dialog.addEventListener('close', cleanup);
      dialog.addEventListener('cancel', (e) => { e.preventDefault(); finish('declined'); });
      dialog.addEventListener('click', (e) => {
        const el = e.target instanceof Element ? e.target : null;
        if (!el) return;
        if (el === dialog || el.closest('[data-nl-offer-decline]')) return finish('declined');
        const tabBtn = el.closest('[data-nl-offer-tab]');
        if (tabBtn && shop) return shop.select(tabBtn.dataset.nlOfferTab);
        const tile = el.closest('[data-nl-offer-tile]');
        if (tile && shop) return shop.toggle(tile);
        const yes = el.closest('[data-nl-offer-accept]');
        if (yes && !yes.disabled && !yes.classList.contains('is-loading')) {
          yes.classList.add('is-loading');
          yes.setAttribute('aria-busy', 'true');
          const items = shop ? shop.items() : [{ id: Number(yes.dataset.nlOfferAccept), quantity: 1 }];
          if (!items.length) { yes.classList.remove('is-loading'); return; }
          addItems(items, 'nl-offer')
            .then(() => {
              yes.classList.remove('is-loading');
              yes.classList.add('is-done');
              yes.textContent = 'Προστέθηκε 🧡 Ευχαριστούμε!';
              setTimeout(() => finish('accepted'), 750);
            })
            .catch((err) => {
              yes.classList.remove('is-loading');
              yes.removeAttribute('aria-busy');
              flashError(dialog.querySelector('.nl-offer__actions'), err.message);
            });
        }
      });
      dialog.setAttribute('tabindex', '-1');
      dialog.showModal();
      dialog.focus();
    });
  }
  window.addEventListener('cart:update', (event) => {
    const data = (event.detail && event.detail.data) || {};
    const drawer = document.querySelector('cart-drawer-component');
    if (offerBusy) {
      if (drawer && drawer.hasAttribute('auto-open')) drawer.removeAttribute('auto-open');
      return;
    }
    if (data.didError || (data.source !== 'product-form-component' && data.source !== 'nl-bundle') || !offerEligible()) return;
    const hadAutoOpen = !!drawer && drawer.hasAttribute('auto-open');
    if (hadAutoOpen) drawer.removeAttribute('auto-open');
    offerBusy = true;
    fetchOffer()
      .then(({ content, disabled }) => {
        if (disabled) offerSave({ off: true });
        if (!content) return 'none';
        document.querySelectorAll('dialog.quick-add-modal[open], quick-add-dialog dialog[open]').forEach((d) => d.close());
        offerSave({ shown: (offerState().shown || 0) + 1 });
        return showOffer(content);
      })
      .then((result) => { if (result === 'declined') offerSave({ declined: true }); })
      .finally(() => {
        offerBusy = false;
        if (hadAutoOpen) {
          const current = document.querySelector('cart-drawer-component');
          if (current) current.setAttribute('auto-open', '');
          openCartDrawer();
        }
      });
  }, true);

  /* ---------- quick add buttons (cards, upsells) ---------- */
  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-nl-add]') : null;
    if (!btn) return;
    event.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    const label = btn.textContent;
    btn.classList.add('is-loading');
    addItems([{ id: Number(btn.dataset.nlAdd), quantity: 1 }])
      .then(() => {
        btn.textContent = btn.dataset.added || 'Προστέθηκε ✓';
        btn.closest('.nl-up')?.classList.add('is-added');
        setTimeout(() => { if (btn.isConnected) btn.textContent = label; }, 2500);
      })
      .catch((err) => flashError(btn.closest('.nl-ups, .nl-card, .nl-cart-ups') || btn.parentElement, err.message))
      .finally(() => btn.classList.remove('is-loading'));
  });

  document.addEventListener('cart:update', () => {
    document.querySelectorAll('[data-nl-refresh]').forEach(async (el) => {
      try {
        const html = await fetch(`${window.location.pathname}?section_id=${el.dataset.nlRefresh}`).then((r) => r.text());
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nl-refresh]');
        if (fresh) { el.innerHTML = fresh.innerHTML; initShip(el); applyTabs(el); }
      } catch {}
    });
    [60, 500, 1500].forEach((ms) => setTimeout(() => initShip(document), ms));
  });

  /* ---------- delivery dates, countdown, reveal ---------- */
  function addBusinessDays(from, days) {
    const d = new Date(from);
    let left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left--;
    }
    return d;
  }
  const fmt = (d) => `${d.getDate()} ${MONTHS[d.getMonth()]}`;
  function initShip(root = document) {
    root.querySelectorAll('[data-nl-ship]').forEach((el) => {
      const [min, max] = (el.dataset.nlShip || '0').split('-').map(Number);
      const now = new Date();
      const a = addBusinessDays(now, min || 0);
      const b = addBusinessDays(now, Number.isFinite(max) ? max : min || 0);
      const txt = a.getTime() === b.getTime() ? fmt(a) : a.getMonth() === b.getMonth() ? `${a.getDate()}–${fmt(b)}` : `${fmt(a)} – ${fmt(b)}`;
      if (el.textContent !== txt) el.textContent = txt;
    });
  }
  function initCountdown(root = document) {
    root.querySelectorAll('[data-nl-countdown]').forEach((el) => {
      if (el.__nl) return;
      el.__nl = true;
      const end = new Date(el.dataset.nlCountdown).getTime();
      const host = el.closest('[data-nl-countdown-host]') || el;
      const tick = () => {
        const left = end - Date.now();
        if (!(left > 0)) { host.hidden = true; clearInterval(timer); return; }
        const s = Math.floor(left / 1000);
        const parts = [[Math.floor(s / 86400), 'ημ.'], [Math.floor((s % 86400) / 3600), 'ώρ.'], [Math.floor((s % 3600) / 60), 'λεπ.'], [s % 60, 'δευτ.']];
        el.innerHTML = parts.map(([v, l]) => `<i>${String(v).padStart(2, '0')}<small>${l}</small></i>`).join('');
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }
  let revealIO = null;
  function initReveal(root = document) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || (window.Shopify && window.Shopify.designMode)) return;
    document.documentElement.classList.add('nl-js');
    if (!revealIO) {
      revealIO = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); revealIO.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    const limit = window.innerHeight * 0.95;
    root.querySelectorAll('.nl-sec > .nl-wrap > *').forEach((el) => {
      if (el.classList.contains('nl-reveal') || el.getBoundingClientRect().top < limit) return;
      el.classList.add('nl-reveal');
      revealIO.observe(el);
    });
  }
  function init(root) { initShip(root); initCountdown(root); initReveal(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));

  /* ---------- simple tabs ---------- */
  const tabState = {};
  function applyTabs(root = document) {
    root.querySelectorAll('[data-nl-tabs]').forEach((host) => {
      const want = tabState[host.dataset.nlTabs];
      if (!want || !host.querySelector(`[data-nl-panel="${want}"]`)) return;
      host.querySelectorAll('[data-nl-tab]').forEach((tab) => {
        const on = String(tab.dataset.nlTab === want);
        if (tab.getAttribute('aria-selected') !== on) tab.setAttribute('aria-selected', on);
      });
      host.querySelectorAll('[data-nl-panel]').forEach((panel) => {
        const hide = panel.dataset.nlPanel !== want;
        if (panel.hidden !== hide) panel.hidden = hide;
      });
    });
  }
  document.addEventListener('click', (e) => {
    const tab = e.target instanceof Element ? e.target.closest('[data-nl-tab]') : null;
    if (!tab) return;
    const host = tab.closest('[data-nl-tabs]');
    if (!host) return;
    e.preventDefault();
    tabState[host.dataset.nlTabs] = tab.dataset.nlTab;
    applyTabs(document);
  });
  if ('MutationObserver' in window) {
    let t;
    new MutationObserver(() => { applyTabs(document); clearTimeout(t); t = setTimeout(() => initShip(document), 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
